import React from 'react';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import { observer } from 'mobx-react';
import { action, extendObservable } from 'mobx';

import ConfirmPassword from '../../_shared/Fields/ConfirmPassword';
import Password from '../../_shared/Fields/Password';
import Username from '../../_shared/Fields/Username';
import * as validate from '../../../helpers/formValidation';
import {
    SERVER_ERROR,
    USERNAME_INCORRECT_MSG,
    INVITATION_EXPIRED_MSG,
    DEFAULT_ERROR_MSG,
} from '../../../helpers/messageText';

import store from '../../../stores/store';

const ResetForm = observer(
    class ResetForm extends React.Component {
        constructor(props) {
            super(props);

            super(props);
            // magic and here
            // better to mutate data which observable by actions!
            this.form = extendObservable(this, {
                token: '',
                username: '',
                usernameFieldState: true,
                password: '',
                passwordFieldState: true,
                confirmPassword: '',
                confirmPasswordFieldState: true,
                error: '',
                pending: false,
                blocking: false,

                set: action((field, value) => {
                    this[field] = value;
                }),
                get canSubmitForm() {
                    return (
                        this.confirmPasswordFieldState &&
                        this.usernameFieldState &&
                        this.passwordFieldState &&
                        this.username &&
                        this.password &&
                        this.confirmPassword
                    );
                },
            });
        }

        componentWillMount() {
            // console.log('reset page');
            this.form.set('blocking', true);
            const token = this.props.location.search.substring(1);
            if (token !== undefined && token.length > 0) {
                // check if the token exists and is valid
                this.form.set('pending', true);
                store.user
                    .verifyUserPortalPasswordToken(token)
                    .then(json => {
                        this.form.set('token', token);
                        this.form.set('pending', false);
                        this.form.set('blocking', false);
                    })
                    .catch(e => {
                        var message = '';
                        if (
                            e !== undefined &&
                            e.spread !== undefined &&
                            e.spread.Message !== undefined
                        ) {
                            this.form.set('error', e.spread.Message);
                            message = e.spread.Message;
                        } else {
                            message = 'Error';
                        }
                        this.form.set('pending', false);
                        this.form.set('blocking', false);
                        this.props.history.push('/login/?' + message);
                    });
            } else {
                this.form.set('pending', false);
                this.form.set('blocking', false);
                this.props.history.push(
                    '/login/?You are not authorized to access the requested page.',
                );
            }
        }

        onReturnHandler = () => {
            this.props.history.push('/login');
        };

        handleChange = e => {
            this.form.set('error', '');
            switch (e.target.name) {
                case 'password':
                    let errPwdCount = validate.password(e.target.value);
                    this.form.set('passwordFieldState', errPwdCount === 0);
                    this.form.set('password', e.target.value);

                    //if confirmPassword is not empty, check if the changed password field matches
                    if (
                        this.form.confirmPassword !== '' &&
                        this.form.confirmPassword !== e.target.value
                    ) {
                        this.form.set('confirmPasswordFieldState', false);
                    } else {
                        this.form.set('confirmPasswordFieldState', true);
                    }

                    break;

                case 'username':
                    // Username - Mandatory, 5-50 chars, alphanumeric, no spaces
                    let errCount = validate.required(e.target.value);
                    errCount += validate.length(e.target.value, 5, 50);
                    errCount += validate.alphanumeric(e.target.value);
                    this.form.set('usernameFieldState', errCount === 0);
                    this.form.set('username', e.target.value);

                    break;

                case 'confirmPassword':
                    if (this.form.confirmPassword === '' || this.form.password !== e.target.value) {
                        this.form.set('confirmPasswordFieldState', false);
                    } else {
                        this.form.set('confirmPasswordFieldState', true);
                    }

                    this.form.set('confirmPassword', e.target.value);
                    break;

                default:
                    break;
            }
        };

        handleSubmit = event => {
            event.preventDefault();

            const credentials = {
                username: this.form.username,
                password: this.form.password,
                token: this.form.token,
            };

            this.form.set('pending', true);
            store.user
                .reset(credentials)
                .then(json => {
                    this.form.set('pending', false);
                    this.loginUser(credentials);
                })
                .catch(e => {
                    // console.log('handleSubmit error ', e);
                    this.form.set('pending', false);
                    if (
                        e !== undefined &&
                        e.spread !== undefined &&
                        e.spread.Details !== undefined &&
                        e.spread.Details.Error !== undefined
                    ) {
                        if (e.spread.Details.Error === 'User not found.') {
                            this.form.set('error', USERNAME_INCORRECT_MSG);
                        } else if (e.spread.Details.Error === 'The invitation has expired.') {
                            this.form.set('error', INVITATION_EXPIRED_MSG);
                        } else {
                            this.form.set('error', e.spread.Details.Error);
                        }
                    } else {
                        this.form.set('error', DEFAULT_ERROR_MSG);
                    }
                });
        };

        loginUser = credentials => {
            store.user.login(credentials).catch(e => {
                this.form.set('pending', false);
                if (
                    e !== undefined &&
                    e.spread !== undefined &&
                    (e.spread.error_description !== undefined || e.message !== undefined)
                ) {
                    this.form.set('error', e.spread.error_description || e.message);
                } else {
                    this.form.set('error', DEFAULT_ERROR_MSG);
                }
            });
        };

        render() {
            // let submitClass =
            //     'btn btn-primary btn-block ' + (this.form.canSubmitForm ? '' : 'disabled');
            return (
                <div>
                    <BlockUi tag="div" blocking={this.form.blocking}>
                        {/* <!-- Form --> */}
                        <div className="mt-3">
                            {this.form.error !== '' && (
                                <div className="alert alert-danger mt-4" role="alert">
                                    {this.form.error === '' ? SERVER_ERROR : this.form.error}
                                </div>
                            )}
                            <form className="" onSubmit={this.handleSubmit}>
                                <legend>
                                    <span className="legend-border-bottom">Reset Password</span>
                                </legend>
                                <hr />
                                <Username
                                    handleChange={this.handleChange}
                                    fieldState={this.form.usernameFieldState}
                                    defaultValue={this.form.username}
                                />
                                <Password
                                    handleChange={this.handleChange}
                                    fieldState={this.form.passwordFieldState}
                                    defaultValue={this.form.password}
                                />
                                <ConfirmPassword
                                    handleChange={this.handleChange}
                                    fieldState={this.form.confirmPasswordFieldState}
                                    defaultValue={this.form.confirmPassword}
                                />

                                <div className="form-group row">
                                    <div className="col-sm-8 offset-sm-4">
                                        <LaddaButton
                                            className="btn btn-primary btn-block"
                                            loading={this.form.pending}
                                            onClick={this.handleSubmit}
                                            disabled={!this.form.canSubmitForm}
                                            data-size={S}
                                            data-style={SLIDE_LEFT}
                                            data-spinner-size={30}
                                            data-spinner-color="#fff"
                                            data-spinner-lines={12}
                                        >
                                            Reset password
                                        </LaddaButton>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {/* <!-- Items below Form --> */}
                        <div className="">
                            <hr />
                            <div className="row justify-content-center pl-4 pr-3 pb-3">
                                <a
                                    onClick={this.onReturnHandler}
                                    className="col-sm-8 offset-sm-4 btn btn-outline-primary no-outline"
                                >
                                    Return to Sign in
                                </a>
                            </div>
                        </div>
                    </BlockUi>
                </div>
            );
        }
    },
);

export default ResetForm;



// WEBPACK FOOTER //
// ./src/containers/PublicArea/components/ResetForm.js